import {EngagementId, PaginationArgs, SampleId, TestId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const sampleTests = typedQuery(["tprm", "sampleTests", param<SampleId>("sampleId")], async sampleId => {
  return await api.tprm.tests.listForSample(sampleId);
});

export const test = typedQuery(["tprm", "test", param<TestId>("testId")], async testId => {
  return await api.tprm.tests.get(testId);
});

export const testEvidence = typedQuery(["tprm", "testEvidence", param<TestId>("testId")], async testId => {
  return await api.tprm.tests.listEvidence(testId);
});

export const testItems = typedQuery(
  ["tprm", "testItems", param<TestId>("testId"), param<PaginationArgs>("pagination")],
  async (testId, pagination) => {
    return await api.tprm.tests.listItems(testId, pagination);
  },
);

export const engagementTests = typedQuery(
  ["tprm", "engagementTests", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.tests.list(engagementId);
  },
);

export const engagementTestTemplates = typedQuery(
  ["tprm", "engagementTestTemplates", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.testTemplates.list(engagementId);
  },
);
